var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 80,
    viewBox: "0 0 110 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8367 0L41.1633 16.9128C39.6421 16.8233 38.5682 16.9128 37.3154 17.0917L38.8367 0Z",
    fill: "url(#paint0_linear_181252_182248)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6777 8.67969L35.7046 17.3598C34.8097 17.5387 34.0938 17.7177 33.2885 17.9862L31.6777 8.67969Z",
    fill: "url(#paint1_linear_181252_182248)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9082 3.9375L31.9462 18.4341C30.5145 18.8816 29.6196 19.508 28.4563 20.1344L22.9082 3.9375Z",
    fill: "url(#paint2_linear_181252_182248)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.313 14.4971L27.3823 20.8505C26.6665 21.298 26.0401 21.8349 25.4137 22.3718L20.313 14.4971Z",
    fill: "url(#paint3_linear_181252_182248)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4697 13.0645L24.0715 23.3553C22.9082 24.3396 22.2818 25.2345 21.4764 26.2188L10.4697 13.0645Z",
    fill: "url(#paint4_linear_181252_182248)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5435 24.3398L20.492 27.5613C20.0446 28.2772 19.5971 28.9931 19.2392 29.709L11.5435 24.3398Z",
    fill: "url(#paint5_linear_181252_182248)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87939 27.8301L18.5237 31.5885C17.8973 32.9307 17.6288 34.0046 17.2709 35.2574L1.87939 27.8301Z",
    fill: "url(#paint6_linear_181252_182248)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5166 37.4942L17.0021 36.7783C16.8231 37.6732 16.8231 38.3891 16.7336 39.2839L7.5166 37.4942Z",
    fill: "url(#paint7_linear_181252_182248)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.0271L16.7338 40.8057C16.6443 42.3269 16.9128 43.4007 17.0917 44.6535L0 44.0271Z",
    fill: "url(#paint8_linear_181252_182248)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76953 50.2013L17.3601 46.085C17.5391 46.8903 17.7181 47.6957 18.076 48.5011L8.76953 50.2013Z",
    fill: "url(#paint9_linear_181252_182248)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83203 60.1347L18.6128 50.1123C19.1497 51.4546 19.8656 52.3494 20.5815 53.4233L4.83203 60.1347Z",
    fill: "url(#paint10_linear_181252_182248)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3916 62.1927L21.5661 54.9443C22.103 55.6602 22.5504 56.2866 23.1768 56.913L15.3916 62.1927Z",
    fill: "url(#paint11_linear_181252_182248)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2124 72.5726L24.5189 58.2549C25.5927 59.3287 26.4876 59.9551 27.5614 60.671L15.2124 72.5726Z",
    fill: "url(#paint12_linear_181252_182248)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3086 70.6939L28.9037 61.5664C29.6196 62.0138 30.3354 62.3718 31.1408 62.6402L26.3086 70.6939Z",
    fill: "url(#paint13_linear_181252_182248)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0669 80L32.9304 63.1768C34.2727 63.7137 35.436 63.8926 36.6888 64.1611L30.0669 80Z",
    fill: "url(#paint14_linear_181252_182248)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5526 73.6466L38.2998 64.1611C39.1947 64.2506 40 64.2506 40.8054 64.2506L39.5526 73.6466Z",
    fill: "url(#paint15_linear_181252_182248)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5189 25.5928C32.7515 18.434 45.19 19.3288 52.3488 27.472C52.5278 27.7405 52.7068 27.9194 52.9752 28.1879C46.4428 21.387 35.6151 20.8501 28.4562 27.1141C21.0289 33.557 20.2236 44.8322 26.756 52.349C33.02 59.5078 43.8477 60.4921 51.1855 54.6756C51.0066 54.8545 50.7381 55.123 50.4697 55.302C42.237 62.4608 29.7985 61.566 22.6397 53.4228C15.4808 45.1901 16.3757 32.7516 24.5189 25.5928Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.528 54.5869C52.17 55.0343 51.7226 55.3923 51.2752 55.7502C43.0425 62.9091 30.6935 62.2827 23.1768 54.5869C23.3557 54.8554 23.6242 55.1238 23.8926 55.3923C32.0358 64.7883 46.3535 65.7726 55.7495 57.5399C56.8233 56.6451 57.7181 55.5713 58.613 54.5869H52.528Z",
    fill: "#C6C5C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2439 27.025C53.7809 27.5619 54.2283 28.1883 54.6757 28.8147H60.0448C59.4184 27.7409 58.7026 26.7565 57.8077 25.8617C49.6645 16.4657 35.3468 15.4813 25.9509 23.714C25.6824 23.9825 25.414 24.1614 25.1455 24.4299C33.7361 17.629 46.0851 18.7028 53.2439 27.025Z",
    fill: "#D02027"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8157 43.7715C35.867 43.3954 35.83 43.0819 35.7046 42.8311C35.5793 42.5746 35.397 42.3609 35.1577 42.1899C34.9185 42.0132 34.6507 41.8679 34.3545 41.7539C34.0582 41.6342 33.762 41.523 33.4657 41.4205C33.0385 41.2723 32.6169 41.0984 32.201 40.8989C31.7908 40.6995 31.4205 40.4601 31.0901 40.1808C30.7597 39.8958 30.5004 39.5595 30.3124 39.172C30.1301 38.7844 30.0589 38.3313 30.0988 37.8126C30.1444 37.237 30.3067 36.7325 30.5859 36.2994C30.8651 35.8605 31.2211 35.4957 31.6541 35.2051C32.0871 34.9144 32.5628 34.6978 33.0812 34.5553C33.5996 34.4128 34.1237 34.3473 34.6536 34.3587C35.3885 34.3758 36.0465 34.5411 36.6276 34.8545C37.2087 35.1623 37.6616 35.5955 37.9863 36.154C38.311 36.7126 38.4534 37.3709 38.4136 38.1289L36.807 38.1204C36.8469 37.6245 36.7842 37.1999 36.619 36.8465C36.4538 36.4875 36.1974 36.211 35.8499 36.0172C35.5081 35.8235 35.0865 35.7209 34.5852 35.7095C34.1294 35.6981 33.6936 35.7665 33.2777 35.9147C32.8675 36.0628 32.52 36.2937 32.2352 36.6072C31.9503 36.9149 31.7766 37.3111 31.7139 37.7955C31.6683 38.1318 31.7139 38.4196 31.8506 38.659C31.9874 38.8984 32.1754 39.1007 32.4146 39.266C32.6596 39.4313 32.9245 39.5709 33.2094 39.6849C33.4999 39.7989 33.7762 39.8987 34.0383 39.9842C34.494 40.138 34.9327 40.3204 35.3543 40.5313C35.7816 40.7365 36.1576 40.9873 36.4823 41.2837C36.8127 41.5743 37.0634 41.922 37.2343 42.3267C37.4109 42.7314 37.4764 43.2073 37.4308 43.7544C37.3796 44.3472 37.2115 44.8602 36.9267 45.2933C36.6418 45.7265 36.2772 46.0827 35.8328 46.362C35.3885 46.6356 34.9014 46.8379 34.3716 46.969C33.8417 47.1001 33.3091 47.1599 32.7735 47.1485C32.2152 47.1428 31.6854 47.0545 31.1841 46.8835C30.6884 46.7068 30.2498 46.456 29.8681 46.1312C29.4864 45.8063 29.193 45.413 28.9879 44.9513C28.7828 44.484 28.6945 43.9539 28.723 43.3612L30.321 43.3697C30.2925 43.7687 30.3352 44.1192 30.4492 44.4213C30.5631 44.7234 30.734 44.977 30.9619 45.1822C31.1955 45.3817 31.4718 45.5356 31.7908 45.6438C32.1098 45.7464 32.4602 45.8006 32.8419 45.8063C33.292 45.8177 33.7306 45.755 34.1579 45.6182C34.5909 45.4814 34.9583 45.262 35.2603 44.9599C35.5622 44.6578 35.7474 44.2617 35.8157 43.7715Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5239 33.8457L40.2423 46.9776H38.687L40.9687 33.8457H42.5239ZM47.3949 37.7271L42.8145 41.9676L40.0543 44.4555L40.2423 42.6259L42.0881 40.7451L45.3781 37.7271H47.3949ZM44.3783 46.9776L41.883 42.4806L42.8658 41.1554L46.0703 46.9776H44.3783Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0012 45.926L53.898 37.7271H55.6071L50.1807 48.4138C50.0383 48.7159 49.8702 49.0066 49.6765 49.2859C49.4885 49.5652 49.272 49.8159 49.0271 50.0382C48.7878 50.2605 48.5172 50.4344 48.2152 50.5597C47.9133 50.6851 47.58 50.7478 47.2154 50.7478C47.0616 50.7421 46.9078 50.725 46.754 50.6965C46.5944 50.668 46.4406 50.6367 46.2925 50.6025L46.3865 49.303C46.4549 49.3144 46.5232 49.3229 46.5916 49.3286C46.66 49.34 46.7255 49.3486 46.7881 49.3543C47.1698 49.3657 47.4974 49.3115 47.7709 49.1918C48.05 49.0722 48.2893 48.8955 48.4887 48.6618C48.6938 48.4281 48.8761 48.1488 49.0356 47.8239L50.0012 45.926ZM49.574 37.7271L50.6763 44.9941L50.7789 46.627L49.6252 47.1913L47.9503 37.7271H49.574Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5006 43.7715C77.5519 43.3954 77.5149 43.0819 77.3895 42.8311C77.2642 42.5746 77.0819 42.3609 76.8426 42.1899C76.6034 42.0132 76.3356 41.8679 76.0394 41.7539C75.7431 41.6342 75.4469 41.523 75.1506 41.4205C74.7233 41.2723 74.3018 41.0984 73.8859 40.8989C73.4757 40.6995 73.1054 40.4601 72.775 40.1808C72.4445 39.8958 72.1853 39.5595 71.9973 39.172C71.815 38.7844 71.7438 38.3313 71.7837 37.8126C71.8293 37.237 71.9916 36.7325 72.2708 36.2994C72.5499 35.8605 72.906 35.4957 73.339 35.2051C73.7719 34.9144 74.2476 34.6978 74.7661 34.5553C75.2845 34.4128 75.8086 34.3473 76.3384 34.3587C77.0734 34.3758 77.7314 34.5411 78.3124 34.8545C78.8935 35.1623 79.3465 35.5955 79.6712 36.154C79.9959 36.7126 80.1383 37.3709 80.0985 38.1289L78.4919 38.1204C78.5318 37.6245 78.4691 37.1999 78.3039 36.8465C78.1387 36.4875 77.8823 36.211 77.5348 36.0172C77.193 35.8235 76.7714 35.7209 76.2701 35.7095C75.8143 35.6981 75.3785 35.7665 74.9626 35.9147C74.5524 36.0628 74.2049 36.2937 73.9201 36.6072C73.6352 36.9149 73.4615 37.3111 73.3988 37.7955C73.3532 38.1318 73.3988 38.4196 73.5355 38.659C73.6723 38.8984 73.8602 39.1007 74.0995 39.266C74.3445 39.4313 74.6094 39.5709 74.8943 39.6849C75.1848 39.7989 75.4611 39.8987 75.7232 39.9842C76.1789 40.138 76.6176 40.3204 77.0392 40.5313C77.4664 40.7365 77.8424 40.9873 78.1672 41.2837C78.4976 41.5743 78.7483 41.922 78.9192 42.3267C79.0958 42.7314 79.1613 43.2073 79.1157 43.7544C79.0645 44.3472 78.8964 44.8602 78.6115 45.2933C78.3267 45.7265 77.9621 46.0827 77.5177 46.362C77.0734 46.6356 76.5863 46.8379 76.0564 46.969C75.5266 47.1001 74.994 47.1599 74.4584 47.1485C73.9001 47.1428 73.3703 47.0545 72.869 46.8835C72.3733 46.7068 71.9347 46.456 71.553 46.1312C71.1713 45.8063 70.8779 45.413 70.6728 44.9513C70.4677 44.484 70.3794 43.9539 70.4079 43.3612L72.0059 43.3697C71.9774 43.7687 72.0201 44.1192 72.1341 44.4213C72.248 44.7234 72.4189 44.977 72.6468 45.1822C72.8804 45.3817 73.1567 45.5356 73.4757 45.6438C73.7947 45.7464 74.1451 45.8006 74.5268 45.8063C74.9769 45.8177 75.4155 45.755 75.8428 45.6182C76.2758 45.4814 76.6432 45.262 76.9452 44.9599C77.2471 44.6578 77.4323 44.2617 77.5006 43.7715Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7736 42.5062L80.7992 42.3096C80.8676 41.6883 81.0214 41.0899 81.2606 40.5142C81.5056 39.9386 81.8275 39.4256 82.2263 38.9753C82.6251 38.5251 83.0979 38.1717 83.6448 37.9152C84.1917 37.6587 84.8013 37.539 85.4736 37.5561C86.123 37.5675 86.6785 37.7072 87.1399 37.9751C87.6071 38.2429 87.9831 38.5992 88.2679 39.0437C88.5585 39.4826 88.7607 39.9785 88.8747 40.5313C88.9886 41.0842 89.0171 41.6541 88.9601 42.2412L88.943 42.4378C88.869 43.0591 88.7095 43.6547 88.4645 44.2247C88.2195 44.7946 87.8948 45.3019 87.4903 45.7464C87.0915 46.191 86.6187 46.5415 86.0718 46.798C85.5248 47.0488 84.9181 47.1656 84.2516 47.1485C83.6078 47.1371 83.0524 47.0004 82.5852 46.7382C82.1237 46.4703 81.7506 46.1169 81.4657 45.678C81.1809 45.2392 80.9815 44.7462 80.8676 44.199C80.7536 43.6518 80.7223 43.0876 80.7736 42.5062ZM82.3374 42.3096L82.3203 42.5148C82.2804 42.8738 82.2776 43.2472 82.3117 43.6347C82.3516 44.0223 82.4428 44.3814 82.5852 44.712C82.7333 45.0425 82.947 45.3133 83.2261 45.5242C83.5053 45.735 83.867 45.8462 84.3114 45.8576C84.7842 45.869 85.2001 45.7778 85.559 45.584C85.9179 45.3845 86.2227 45.1166 86.4734 44.7804C86.7298 44.4441 86.932 44.0708 87.0801 43.6604C87.2339 43.25 87.3365 42.8425 87.3878 42.4378L87.4049 42.2412C87.4447 41.8821 87.4447 41.5088 87.4049 41.1212C87.3707 40.728 87.2795 40.3632 87.1314 40.0269C86.989 39.6849 86.7782 39.4085 86.499 39.1976C86.2199 38.981 85.8581 38.867 85.4137 38.8556C84.9409 38.8385 84.5222 38.9326 84.1576 39.1378C83.7987 39.3373 83.4939 39.608 83.2432 39.95C82.9925 40.2919 82.7903 40.671 82.6365 41.087C82.4883 41.4974 82.3886 41.9049 82.3374 42.3096Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0191 33.8457L91.7374 46.9776H90.1907L92.4638 33.8457H94.0191Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7873 45.3959L100.556 40.6168C100.596 40.2634 100.562 39.9528 100.454 39.6849C100.351 39.417 100.178 39.209 99.9325 39.0608C99.6933 38.9126 99.3913 38.8328 99.0267 38.8214C98.7077 38.8157 98.3943 38.867 98.0867 38.9753C97.7848 39.0836 97.5227 39.2461 97.3005 39.4626C97.0783 39.6792 96.9331 39.9528 96.8647 40.2834L95.3265 40.2919C95.3664 39.8303 95.5117 39.4284 95.7623 39.0865C96.013 38.7388 96.3263 38.451 96.7023 38.223C97.0783 37.9893 97.4828 37.8183 97.9158 37.71C98.3488 37.596 98.7703 37.5419 99.1805 37.5476C99.8015 37.559 100.34 37.6929 100.796 37.9494C101.257 38.2002 101.605 38.5536 101.838 39.0095C102.072 39.4655 102.157 40.0127 102.095 40.651L101.385 44.9599C101.334 45.2734 101.303 45.5897 101.291 45.9089C101.286 46.2224 101.323 46.5301 101.402 46.8322L101.385 46.9776L99.8214 46.9861C99.7588 46.7239 99.7274 46.4589 99.7274 46.191C99.7331 45.9231 99.7531 45.6581 99.7873 45.3959ZM100.736 41.3692L100.556 42.4806L99.0951 42.472C98.7874 42.472 98.4627 42.4948 98.1209 42.5404C97.7791 42.586 97.4543 42.6715 97.1467 42.7969C96.8391 42.9223 96.5799 43.1047 96.3691 43.3441C96.1583 43.5777 96.0301 43.8827 95.9845 44.2589C95.9503 44.5666 95.9874 44.8345 96.0956 45.0625C96.2096 45.2848 96.3805 45.4586 96.6083 45.584C96.8362 45.7094 97.1011 45.7749 97.4031 45.7806C97.7962 45.7863 98.1836 45.7094 98.5653 45.5498C98.947 45.3902 99.2802 45.1622 99.5651 44.8659C99.8499 44.5695 100.046 44.2275 100.155 43.8399L100.719 44.6008C100.61 44.977 100.434 45.3247 100.189 45.6438C99.9439 45.9573 99.6534 46.2281 99.3173 46.456C98.9868 46.684 98.6308 46.8607 98.2491 46.9861C97.8674 47.1115 97.4857 47.1713 97.104 47.1656C96.5856 47.1542 96.1156 47.0374 95.694 46.8151C95.2781 46.5928 94.9477 46.2822 94.7027 45.8832C94.4634 45.4786 94.3609 45.0083 94.3951 44.4726C94.4292 43.8855 94.5831 43.3925 94.8565 42.9935C95.13 42.5946 95.4803 42.2754 95.9076 42.036C96.3406 41.7966 96.8134 41.6256 97.3262 41.523C97.8389 41.4148 98.3459 41.3606 98.8473 41.3606L100.736 41.3692Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M106.333 39.2489L104.991 46.9776H103.445L105.051 37.7271H106.555L106.333 39.2489ZM109.333 37.6502L109.187 39.1378C109.068 39.115 108.945 39.095 108.82 39.0779C108.7 39.0608 108.581 39.0523 108.461 39.0523C108.091 39.0466 107.757 39.1036 107.461 39.2233C107.171 39.3373 106.911 39.4997 106.683 39.7106C106.461 39.9215 106.27 40.1694 106.111 40.4544C105.957 40.7394 105.835 41.0471 105.743 41.3777L105.256 41.6342C105.319 41.1725 105.422 40.6995 105.564 40.215C105.712 39.7305 105.914 39.2831 106.171 38.8727C106.433 38.4624 106.76 38.1318 107.153 37.881C107.552 37.6302 108.031 37.5134 108.589 37.5305C108.714 37.5305 108.837 37.5419 108.957 37.5647C109.082 37.5875 109.207 37.616 109.333 37.6502Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5979 34.5293L60.7514 39.2913L64.3918 34.5293H66.3658L61.5205 40.7703L64.4174 46.9772H62.6228L60.4096 42.1211L56.6752 46.9772H54.6841L59.6405 40.6165L56.8205 34.5293H58.5979Z",
    fill: "#C32723"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181252_182248",
    x1: 40.9404,
    y1: 0.763107,
    x2: 35.2258,
    y2: 16.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181252_182248",
    x1: 34.1393,
    y1: 9.35673,
    x2: 31.8128,
    y2: 17.5164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181252_182248",
    x1: 25.0693,
    y1: 3.81614,
    x2: 26.2562,
    y2: 20.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_181252_182248",
    x1: 22.8267,
    y1: 14.2058,
    x2: 23.8982,
    y2: 22.6234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_181252_182248",
    x1: 12.4678,
    y1: 12.1623,
    x2: 19.4679,
    y2: 27.1669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_181252_182248",
    x1: 13.7766,
    y1: 23.0475,
    x2: 17.9262,
    y2: 30.4454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_181252_182248",
    x1: 3.32791,
    y1: 26.1054,
    x2: 15.9232,
    y2: 36.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_181252_182248",
    x1: 9.03498,
    y1: 35.4662,
    x2: 15.8798,
    y2: 40.4746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_181252_182248",
    x1: 0.64608,
    y1: 41.9238,
    x2: 16.4798,
    y2: 46.7623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_181252_182248",
    x1: 9.4316,
    y1: 47.75,
    x2: 17.6141,
    y2: 49.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_181252_182248",
    x1: 4.50827,
    y1: 57.9548,
    x2: 20.9012,
    y2: 55.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_181252_182248",
    x1: 15.0183,
    y1: 59.6315,
    x2: 23.4012,
    y2: 58.3465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_181252_182248",
    x1: 14.1311,
    y1: 70.6354,
    x2: 28.5973,
    y2: 62.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_181252_182248",
    x1: 24.8943,
    y1: 68.5547,
    x2: 31.9779,
    y2: 63.8905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_181252_182248",
    x1: 28.2926,
    y1: 78.6457,
    x2: 38.3605,
    y2: 65.5078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_181252_182248",
    x1: 37.3684,
    y1: 72.2679,
    x2: 42.0139,
    y2: 65.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6921E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.2ab6c13a56e7f562986537bb17bcd626.svg";
export { ForwardRef as ReactComponent };